import { useEffect, useRef, useState } from 'react';

const useHeaderScroll = (inHomePath: boolean, isOpen: boolean) => {
  const [scrollY, setScrollY] = useState(0);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const lastScrollY = useRef(0);
  const leaveTimeout = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => {
    const handleScroll = () => {
      const current = window.scrollY;
      setIsScrollingDown(current > lastScrollY.current && current > 50);
      setScrollY(current);
      lastScrollY.current = current;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Re-sync with the real scroll position on route change. ScrollToTop resets the
  // window to 0, but when it's already at 0 no scroll event fires, leaving a stale
  // scrollY here — which kept the header blue on the home route instead of transparent.
  useEffect(() => {
    const current = window.scrollY;
    setScrollY(current);
    lastScrollY.current = current;
  }, [inHomePath]);

  const transparent = inHomePath && !isMouseOver && scrollY === 0 && !isOpen;

  return {
    slideIn: !isScrollingDown || isOpen,
    transparent,
    mouseHandlers: {
      onMouseEnter: () => {
        // Touch devices emit a synthetic mouseenter on tap with no matching
        // mouseleave, which would permanently stick the header to opaque.
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(leaveTimeout.current);
        setIsMouseOver(true);
      },
      onMouseLeave: () => {
        if (!window.matchMedia('(hover: hover)').matches) return;
        // Delay so moving mouse into a portal dropdown doesn't flash transparency
        leaveTimeout.current = setTimeout(() => setIsMouseOver(false), 120);
      },
    },
  };
};

export default useHeaderScroll;
